import React from "react";
import { Routes } from "react-router-dom";
import { mainRoutes } from "./main";
import { galleryRoutes } from "./gallery";
import { eventRoutes } from "./events";
import { vibesRoutes } from "./vibes";

export const AppRoutes = () => {
  return (
    <Routes>
      {mainRoutes}
      {galleryRoutes}
      {eventRoutes}
      {vibesRoutes}
    </Routes>
  );
};
